// src/components/OnboardVerifiedRoute.tsx
import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import LoadingSpinner from './LoadingSpinner';

export default function OnboardVerifiedRoute() {
  const { currentUser, globalLoading } = useAuth();
  const [loading, setLoading]   = useState(true);
  const [bankingPage,  setBankingPage]  = useState(false);
  const [planPage,     setPlanPage]     = useState(false);
  const [confirmPage,  setConfirmPage]  = useState(false);

  const location = useLocation();

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }
    const q = query(
      collection(db, 'userInfo'),
      where('user', '==', currentUser.uid)
    );
    const unsub = onSnapshot(q, (snapshot) => {
      if (snapshot.empty) {
        // no doc → kick back to “get started”
        setBankingPage(false);
        setPlanPage(false);
        setConfirmPage(false);
      } else {
        const u = snapshot.docs[0].data();
        if (u.onboarding?.setupDetailsComplete && !u.onboarding?.bankingDetailsComplete) {
          setBankingPage(true);
        } else if (u.onboarding?.bankingDetailsComplete && !u.onboarding?.planInformationComplete) {
          setPlanPage(true);
        } else if (u.onboarding?.planInformationComplete && !u.onboarding?.confirmIdentityStarted) {
          setConfirmPage(true);
        }
      }
      setLoading(false);
    });
    return () => unsub();
  }, [currentUser]);

  if (globalLoading || loading) {
    return <LoadingSpinner />;
  }

  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (bankingPage) {
    return <Navigate to="/onboarding-banking-details" replace />;
  }
  if (planPage) {
    return <Navigate to="/onboarding-plan-information" replace />;
  }
  if (confirmPage) {
    return <Navigate to="/onboarding-confirm-identity" replace />;
  }

  return <Outlet />;
}
